// Add non schema related enums here
export const DependencyFormat = {
  NONE: "NONE",
  DETACHED: "DETACHED",
  FOLLOWUP: "FOLLOWUP",
};
export type DependencyFormat =
  (typeof DependencyFormat)[keyof typeof DependencyFormat];

export const TableCustomColumns = {
  CHECKBOX: "CHECKBOX",
  SELECT: "SELECT",
  MEMO: "MEMO",
};
export type TableCustomColumns =
  (typeof TableCustomColumns)[keyof typeof TableCustomColumns];

export const TablePatientInfoColumns = {
  NAME: "NAME",
  NAME_PRONUNCIATION: "NAME_PRONUNCIATION",
  CARD_NUMBER: "CARD_NUMBER",
  DATE_OF_BIRTH: "DATE_OF_BIRTH",
  SEX: "SEX",
  PHONE_NUMBER: "PHONE_NUMBER",
  EMAIL: "EMAIL",
  SUBMISSION_TIMESTAMP: "SUBMISSION_TIMESTAMP",
  APPOINTMENT_HISTORY: "APPOINTMENT_HISTORY",
  GOOGLE_MEET: "GOOGLE_MEET",
  DOSE_HISTORY: "DOSE_HISTORY"
};
export type TablePatientInfoColumns =
  (typeof TablePatientInfoColumns)[keyof typeof TablePatientInfoColumns];

export const AppointmentKeys = {
  MENU: "menuName",
  SUBMENU: "submenuName",
  DATE: "startDate",
  TIME: "startTime",
  NAME: "fullName",
  KANA: "fullNameKana",
  DOB: "dob",
  SEX: "sex",
  CARD: "cardNumber",
  TEL: "tel",
  EMAIL: "email",
  CREATEDAT: "timestamp",
  STATUS: "statusString",
  FORM: "form",
  CHECK: "check",
  SUBMISSION_TIMESTAMP: "submissionTimestamp",
  APPOINTMENT_HISTORY: "appointmentHistory",
  MEET: "meetUrl",
  DOSE_HISTORY: "doseHistory"
};
export type AppointmentKeys =
  (typeof AppointmentKeys)[keyof typeof AppointmentKeys];

export const CsvFormSubmissionPatientInfoKeys = {
  SUBMIT_DATE: "createdAtDate",
  SUBMIT_TIME: "createdAtTime",
  FORM_TITLE: "formLabel",
  PATIENT_NAME: "name",
  PATIENT_NAME_KANA: "kana",
  NEW_OR_RETURN_PATIENT: "newPatient",
  PATIENT_CARD_NUMBER: "cardNumber",
  PATIENT_SEX: "sex",
  PATIENT_DOB: "dob",
  PATIENT_AGE: "age",
  PATIENT_HEIGHT: "height",
  PATIENT_WEIGHT: "weight",
  PATIENT_BMI: "bmi",
  PATIENT_CELL_NUMBER: "cellPhone",
  PATIENT_HOME_NUMBER: "homePhone",
  PATIENT_ADDRESS: "address",
  VISIT_REASON: "formattedVisitReasonAnswer",
  APPOINTMENT_DATE_AND_TIME: "appointmentDatetime",
};
export type CsvFormSubmissionPatientInfoKeys =
  (typeof CsvFormSubmissionPatientInfoKeys)[keyof typeof CsvFormSubmissionPatientInfoKeys];

export const CsvPatientInfoHeaderValues = {
  SUBMIT_DATE: "送信日",
  SUBMIT_TIME: "送信時刻",
  FORM_TITLE: "問診票",
  PATIENT_NAME: "氏名",
  PATIENT_NAME_KANA: "フリガナ",
  NEW_OR_RETURN_PATIENT: "再診",
  PATIENT_CARD_NUMBER: "診察券",
  PATIENT_SEX: "性別",
  PATIENT_DOB: "生年月日",
  PATIENT_AGE: "年齢",
  PATIENT_HEIGHT: "身長",
  PATIENT_WEIGHT: "体重",
  PATIENT_BMI: "BMI",
  PATIENT_CELL_NUMBER: "携帯電話番号",
  PATIENT_HOME_NUMBER: "自宅電話番号",
  PATIENT_ADDRESS: "住所",
  VISIT_REASON: "来院理由",
  APPOINTMENT_DATE_AND_TIME: "予約日時",
};
export type CsvPatientInfoHeaderValues =
  (typeof CsvPatientInfoHeaderValues)[keyof typeof CsvPatientInfoHeaderValues];

export const ExportAllOrByMenu = {
  ALL: "全てのメニュー (患者情報のみ)",
  BY_MENU: "指定メニュー (患者情報・回答データ)",
};
export type ExportAllOrByMenu =
  (typeof ExportAllOrByMenu)[keyof typeof ExportAllOrByMenu];

export const BatchCreateIntervals = {
  EVERYDAY: "day",
  EVERYWEEK: "week",
  EVERYMONTH: "month",
};

export type BatchCreateIntervals =
  (typeof BatchCreateIntervals)[keyof typeof BatchCreateIntervals];

export const LocaleString = {
  JAPANESE: "ja",
  ENGLISH: "en-US",
};
export type LocaleString = (typeof LocaleString)[keyof typeof LocaleString];

export const ExportSubmissionsFileFormats = {
  CSV: "CSV",
  XLSX: "XLSX",
};
export type ExportSubmissionsFileFormats =
  (typeof ExportSubmissionsFileFormats)[keyof typeof ExportSubmissionsFileFormats];

export const CountryData = {
  AFGHANISTAN: { code: "+93", icon: "🇦🇫", name: "AF" },
  ALBANIA: { code: "+355", icon: "🇦🇱", name: "AL" },
  ALGERIA: { code: "+213", icon: "🇩🇿", name: "DZ" },
  ANDORRA: { code: "+376", icon: "🇦🇩", name: "AD" },
  ANGOLA: { code: "+244", icon: "🇦🇴", name: "AO" },
  ARGENTINA: { code: "+54", icon: "🇦🇷", name: "AR" },
  ARMENIA: { code: "+374", icon: "🇦🇲", name: "AM" },
  AUSTRALIA: { code: "+61", icon: "🇦🇺", name: "AU" },
  AUSTRIA: { code: "+43", icon: "🇦🇹", name: "AT" },
  AZERBAIJAN: { code: "+994", icon: "🇦🇿", name: "AZ" },
  BAHAMAS: { code: "+1-242", icon: "🇧🇸", name: "BS" },
  BAHRAIN: { code: "+973", icon: "🇧🇭", name: "BH" },
  BANGLADESH: { code: "+880", icon: "🇧🇩", name: "BD" },
  BELARUS: { code: "+375", icon: "🇧🇾", name: "BY" },
  BELGIUM: { code: "+32", icon: "🇧🇪", name: "BE" },
  BELIZE: { code: "+501", icon: "🇧🇿", name: "BZ" },
  BENIN: { code: "+229", icon: "🇧🇯", name: "BJ" },
  BHUTAN: { code: "+975", icon: "🇧🇹", name: "BT" },
  BOLIVIA: { code: "+591", icon: "🇧🇴", name: "BO" },
  BOSNIA_AND_HERZEGOVINA: { code: "+387", icon: "🇧🇦", name: "BA" },
  BOTSWANA: { code: "+267", icon: "🇧🇼", name: "BW" },
  BRAZIL: { code: "+55", icon: "🇧🇷", name: "BR" },
  BRUNEI: { code: "+673", icon: "🇧🇳", name: "BN" },
  BULGARIA: { code: "+359", icon: "🇧🇬", name: "BG" },
  BURKINA_FASO: { code: "+226", icon: "🇧🇫", name: "BF" },
  CAMBODIA: { code: "+855", icon: "🇰🇭", name: "KH" },
  CAMEROON: { code: "+237", icon: "🇨🇲", name: "CM" },
  CANADA: { code: "+1", icon: "🇨🇦", name: "CA" },
  CHILE: { code: "+56", icon: "🇨🇱", name: "CL" },
  CHINA: { code: "+86", icon: "🇨🇳", name: "CN" },
  COLOMBIA: { code: "+57", icon: "🇨🇴", name: "CO" },
  COSTA_RICA: { code: "+506", icon: "🇨🇷", name: "CR" },
  CROATIA: { code: "+385", icon: "🇭🇷", name: "HR" },
  CUBA: { code: "+53", icon: "🇨🇺", name: "CU" },
  CYPRUS: { code: "+357", icon: "🇨🇾", name: "CY" },
  CZECH_REPUBLIC: { code: "+420", icon: "🇨🇿", name: "CZ" },
  DENMARK: { code: "+45", icon: "🇩🇰", name: "DK" },
  DOMINICAN_REPUBLIC: { code: "+1-809", icon: "🇩🇴", name: "DO" },
  ECUADOR: { code: "+593", icon: "🇪🇨", name: "EC" },
  EGYPT: { code: "+20", icon: "🇪🇬", name: "EG" },
  EL_SALVADOR: { code: "+503", icon: "🇸🇻", name: "SV" },
  ESTONIA: { code: "+372", icon: "🇪🇪", name: "EE" },
  ETHIOPIA: { code: "+251", icon: "🇪🇹", name: "ET" },
  FIJI: { code: "+679", icon: "🇫🇯", name: "FJ" },
  FINLAND: { code: "+358", icon: "🇫🇮", name: "FI" },
  FRANCE: { code: "+33", icon: "🇫🇷", name: "FR" },
  GABON: { code: "+241", icon: "🇬🇦", name: "GA" },
  GEORGIA: { code: "+995", icon: "🇬🇪", name: "GE" },
  GERMANY: { code: "+49", icon: "🇩🇪", name: "DE" },
  GHANA: { code: "+233", icon: "🇬🇭", name: "GH" },
  GREECE: { code: "+30", icon: "🇬🇷", name: "GR" },
  GUATEMALA: { code: "+502", icon: "🇬🇹", name: "GT" },
  HAITI: { code: "+509", icon: "🇭🇹", name: "HT" },
  HONDURAS: { code: "+504", icon: "🇭🇳", name: "HN" },
  HONG_KONG: { code: "+852", icon: "🇭🇰", name: "HK" },
  HUNGARY: { code: "+36", icon: "🇭🇺", name: "HU" },
  ICELAND: { code: "+354", icon: "🇮🇸", name: "IS" },
  INDIA: { code: "+91", icon: "🇮🇳", name: "IN" },
  INDONESIA: { code: "+62", icon: "🇮🇩", name: "ID" },
  IRAN: { code: "+98", icon: "🇮🇷", name: "IR" },
  IRAQ: { code: "+964", icon: "🇮🇶", name: "IQ" },
  IRELAND: { code: "+353", icon: "🇮🇪", name: "IE" },
  ISRAEL: { code: "+972", icon: "🇮🇱", name: "IL" },
  ITALY: { code: "+39", icon: "🇮🇹", name: "IT" },
  IVORY_COAST: { code: "+225", icon: "🇨🇮", name: "CI" },
  JAMAICA: { code: "+1-876", icon: "🇯🇲", name: "JM" },
  JAPAN: { code: "+81", icon: "🇯🇵", name: "JP" },
  JORDAN: { code: "+962", icon: "🇯🇴", name: "JO" },
  KAZAKHSTAN: { code: "+7", icon: "🇰🇿", name: "KZ" },
  KENYA: { code: "+254", icon: "🇰🇪", name: "KE" },
  KUWAIT: { code: "+965", icon: "🇰🇼", name: "KW" },
  KYRGYZSTAN: { code: "+996", icon: "🇰🇬", name: "KG" },
  LAOS: { code: "+856", icon: "🇱🇦", name: "LA" },
  LATVIA: { code: "+371", icon: "🇱🇻", name: "LV" },
  LEBANON: { code: "+961", icon: "🇱🇧", name: "LB" },
  LIBYA: { code: "+218", icon: "🇱🇾", name: "LY" },
  LIECHTENSTEIN: { code: "+423", icon: "🇱🇮", name: "LI" },
  LITHUANIA: { code: "+370", icon: "🇱🇹", name: "LT" },
  LUXEMBOURG: { code: "+352", icon: "🇱🇺", name: "LU" },
  MACAU: { code: "+853", icon: "🇲🇴", name: "MO" },
  MADAGASCAR: { code: "+261", icon: "🇲🇬", name: "MG" },
  MALAYSIA: { code: "+60", icon: "🇲🇾", name: "MY" },
  MALDIVES: { code: "+960", icon: "🇲🇻", name: "MV" },
  MALI: { code: "+223", icon: "🇲🇱", name: "ML" },
  MALTA: { code: "+356", icon: "🇲🇹", name: "MT" },
  MEXICO: { code: "+52", icon: "🇲🇽", name: "MX" },
  MOLDOVA: { code: "+373", icon: "🇲🇩", name: "MD" },
  MONACO: { code: "+377", icon: "🇲🇨", name: "MC" },
  MONGOLIA: { code: "+976", icon: "🇲🇳", name: "MN" },
  MONTENEGRO: { code: "+382", icon: "🇲🇪", name: "ME" },
  MOROCCO: { code: "+212", icon: "🇲🇦", name: "MA" },
  MOZAMBIQUE: { code: "+258", icon: "🇲🇿", name: "MZ" },
  MYANMAR: { code: "+95", icon: "🇲🇲", name: "MM" },
  NAMIBIA: { code: "+264", icon: "🇳🇦", name: "NA" },
  NEPAL: { code: "+977", icon: "🇳🇵", name: "NP" },
  NETHERLANDS: { code: "+31", icon: "🇳🇱", name: "NL" },
  NEW_ZEALAND: { code: "+64", icon: "🇳🇿", name: "NZ" },
  NICARAGUA: { code: "+505", icon: "🇳🇮", name: "NI" },
  NIGERIA: { code: "+234", icon: "🇳🇬", name: "NG" },
  NORTH_KOREA: { code: "+850", icon: "🇰🇵", name: "KP" },
  NORWAY: { code: "+47", icon: "🇳🇴", name: "NO" },
  OMAN: { code: "+968", icon: "🇴🇲", name: "OM" },
  PAKISTAN: { code: "+92", icon: "🇵🇰", name: "PK" },
  PALESTINE: { code: "+970", icon: "🇵🇸", name: "PS" },
  PANAMA: { code: "+507", icon: "🇵🇦", name: "PA" },
  PARAGUAY: { code: "+595", icon: "🇵🇾", name: "PY" },
  PERU: { code: "+51", icon: "🇵🇪", name: "PE" },
  PHILIPPINES: { code: "+63", icon: "🇵🇭", name: "PH" },
  POLAND: { code: "+48", icon: "🇵🇱", name: "PL" },
  PORTUGAL: { code: "+351", icon: "🇵🇹", name: "PT" },
  QATAR: { code: "+974", icon: "🇶🇦", name: "QA" },
  ROMANIA: { code: "+40", icon: "🇷🇴", name: "RO" },
  RUSSIA: { code: "+7", icon: "🇷🇺", name: "RU" },
  RWANDA: { code: "+250", icon: "🇷🇼", name: "RW" },
  SAUDI_ARABIA: { code: "+966", icon: "🇸🇦", name: "SA" },
  SENEGAL: { code: "+221", icon: "🇸🇳", name: "SN" },
  SERBIA: { code: "+381", icon: "🇷🇸", name: "RS" },
  SINGAPORE: { code: "+65", icon: "🇸🇬", name: "SG" },
  SLOVAKIA: { code: "+421", icon: "🇸🇰", name: "SK" },
  SLOVENIA: { code: "+386", icon: "🇸🇮", name: "SI" },
  SOMALIA: { code: "+252", icon: "🇸🇴", name: "SO" },
  SOUTH_AFRICA: { code: "+27", icon: "🇿🇦", name: "ZA" },
  SOUTH_KOREA: { code: "+82", icon: "🇰🇷", name: "KR" },
  SPAIN: { code: "+34", icon: "🇪🇸", name: "ES" },
  SRI_LANKA: { code: "+94", icon: "🇱🇰", name: "LK" },
  SUDAN: { code: "+249", icon: "🇸🇩", name: "SD" },
  SWEDEN: { code: "+46", icon: "🇸🇪", name: "SE" },
  SWITZERLAND: { code: "+41", icon: "🇨🇭", name: "CH" },
  SYRIA: { code: "+963", icon: "🇸🇾", name: "SY" },
  TAIWAN: { code: "+886", icon: "🇹🇼", name: "TW" },
  TAJIKISTAN: { code: "+992", icon: "🇹🇯", name: "TJ" },
  TANZANIA: { code: "+255", icon: "🇹🇿", name: "TZ" },
  THAILAND: { code: "+66", icon: "🇹🇭", name: "TH" },
  TUNISIA: { code: "+216", icon: "🇹🇳", name: "TN" },
  TURKEY: { code: "+90", icon: "🇹🇷", name: "TR" },
  TURKMENISTAN: { code: "+993", icon: "🇹🇲", name: "TM" },
  UGANDA: { code: "+256", icon: "🇺🇬", name: "UG" },
  UKRAINE: { code: "+380", icon: "🇺🇦", name: "UA" },
  UNITED_ARAB_EMIRATES: { code: "+971", icon: "🇦🇪", name: "AE" },
  UNITED_KINGDOM: { code: "+44", icon: "🇬🇧", name: "GB" },
  UNITED_STATES: { code: "+1", icon: "🇺🇸", name: "US" },
  URUGUAY: { code: "+598", icon: "🇺🇾", name: "UY" },
  UZBEKISTAN: { code: "+998", icon: "🇺🇿", name: "UZ" },
  VATICAN_CITY: { code: "+379", icon: "🇻🇦", name: "VA" },
  VENEZUELA: { code: "+58", icon: "🇻🇪", name: "VE" },
  VIETNAM: { code: "+84", icon: "🇻🇳", name: "VN" },
  YEMEN: { code: "+967", icon: "🇾🇪", name: "YE" },
  ZAMBIA: { code: "+260", icon: "🇿🇲", name: "ZM" },
  ZIMBABWE: { code: "+263", icon: "🇿🇼", name: "ZW" },
  OTHER: { code: "+0", icon: "", name: "" },
} as const;